var path = '/modules/contacts/views/pages/details/rsvps.tpl.html';
var html = "<contact-rsvps ng-if=\"vm.contact\" contact=\"vm.contact\"></contact-rsvps>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/contacts/views/pages/details/rsvps.tpl.html
// module id = 2078
// module chunks = 1